import React, { useContext, useEffect, useState } from 'react'
import Top from '../components/top'
import Table from '../components/table'
import { DetailsContext } from '../contexts/DetailsContext'
import { AuthContext } from '../contexts/AuthProvider'
import { useNavigate } from 'react-router-dom'

const Gateway = () => {
    const {
        general,
        setGeneral,
        orders,
        setOrders,
        transactions,
        setTransactions,
        admins,
        setAdmins,
        services,
        setServices,
        forms,
        setForms,
        featured,
        setFeatured,
        payments,
        setPayments,
        sms,
        setSms,
        latestOrders,
        setLatestOrders,
        latestTransactions,
        setLatestTransactions,
        adminDetails,
        setAdminDetails
      } = useContext(DetailsContext)
      const {
        user,
        setUser,
        isLogged,
        setIsLogged,
        login,
        logout
      } = useContext(AuthContext)
      const inputs = [
        {
          name: "provider",
          icon: 'fa-solid fa-cube',
          type: 'text',
          placeholder: 'Enter Provider Name'
        },
        {
            name: "account",
            icon: 'fa-solid fa-cube',
            type: 'text',
            placeholder: 'Enter Account'
          },
        {
          name: "gateway_type",
          icon: 'fa-solid fa-user',
          type: 'select',
          vals: [
            {
                name: 'Auto',
                option: 'Auto'
            },
            {
                name: 'Manual',
                option: 'Manual'
            },
          ]
        },
          
      ]
    let gateColumns = ['ID', 'Provider Name', 'Account', 'Gateway Type']
    let gateway = [
        {
            provider: 'Payhero',
            account: '1546365',
            status: 'Active'
        },
    ]
    function addGate(){
        window.location.replace('/edit')
    }
    const [showModal, setShowModal] = useState(false);
    const link = 'https://enky.xgramm.com/enky_backend/admins/payment.php'
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])
  return (
    <div style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={true} value='Add New Provider' name='Gateways'/>
        <div className="w3-container">
        <Table tableName='payment' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Payment Gateways' columns={gateColumns} data={payments} summary={false} edit={true}/>
        </div>
    </div>
  )
}

export default Gateway